/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { Box, Divider, Skeleton } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { AlignCenter } from '../../../../../../components/AlignCenter/AlignCenter';
import { useBackupsConfigureStyles } from '../../../../../../styles/backupsConfigure';
import { createBackupsTableStyles } from '../BackupsTable/BackupsTable.styles';

const SkeletonBackupsTable = memo(() => {
  const classes = createBackupsTableStyles();

  return (
    <Box className={classes.root}>
      <Skeleton variant="text" width="113px" sx={{ fontSize: '20px' }} />
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell variant="head" classes={{ root: classes.tableHeadCell }}>
              <Skeleton variant="text" width="45px" sx={{ fontSize: '16px' }} />
            </TableCell>
            <TableCell variant="head" classes={{ root: classes.tableHeadCell }}>
              <Skeleton variant="text" width="38px" sx={{ fontSize: '16px' }} />
            </TableCell>
            <TableCell variant="head" classes={{ root: classes.tableHeadCell }}>
              <Skeleton variant="text" width="67px" sx={{ fontSize: '16px' }} />
            </TableCell>
            <TableCell colSpan={2} variant="head" classes={{ root: classes.tableHeadCell }}>
              <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'center' }}>
                <Skeleton
                  variant="rounded"
                  width="147px"
                  height="40px"
                  sx={{ borderRadius: '6px', margin: '16px 0' }}
                />
              </div>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={5} classes={{ root: classes.tableCell }}>
              <AlignCenter>
                <Skeleton variant="text" width="191px" sx={{ fontSize: '14px' }} />
              </AlignCenter>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
});

export const SkeletonBackupsLogical = memo(() => {
  const classes = useBackupsConfigureStyles();

  return (
    <div className={classes.root}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Skeleton variant="rounded" width="40px" height="18px" sx={{ borderRadius: '20px', mr: '20px' }} />{' '}
            {/* Skeleton Switch element */}
            <Skeleton variant="text" width="203px" sx={{ fontSize: '20px' }} />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: '16px' }}>
            <Skeleton variant="rounded" width="200px" height="48px" sx={{ borderRadius: '6px', mr: '16px' }} />
            <Skeleton variant="rounded" width="200px" height="48px" sx={{ borderRadius: '6px' }} />
          </Box>
          <Divider component="div" sx={{ mt: '16px', mb: '16px', maxWidth: '595px' }} />
          <Box sx={{ display: 'flex' }}>
            <div>
              <Skeleton variant="text" width="203px" sx={{ fontSize: '16px' }} />
              <Box sx={{ mt: '5px', ml: '5px' }}>
                <Skeleton variant="text" width="290px" sx={{ fontSize: '14px' }} />
                <Skeleton variant="text" width="290px" sx={{ fontSize: '14px' }} />
              </Box>
              <Skeleton variant="text" width="208px" sx={{ fontSize: '14px', mt: '12px', ml: '5px' }} />
            </div>
          </Box>
        </div>
      </Box>
      <Divider component="div" sx={{ mt: '16px', mb: '16px', maxWidth: '595px' }} />
      <SkeletonBackupsTable />
    </div>
  );
});
